import { FileManaged } from './FileManaged';
import { AgentReportResponse } from './AgentReportResponse';

export enum AgentRequestPrescoringStatusEnum {
  ONLY_BY_TRANSPORT = 'ONLY_BY_TRANSPORT',
  SECURED_BY_TRANSPORT = 'SECURED_BY_TRANSPORT',
  PROCESSING = 'PROCESSING',
  PASSED = 'PASSED',
}

export interface AgentRequestResponse {
  inn: string;
  contactName?: string;
  contactPhone?: string;
  amountRequested?: string;
  offerAmountActual?: string;
  companyName?: string;
  termRequested?: string;
  hasPledge?: boolean;
  comment?: string;
  id: number | string;
  status: string;
  reasonRefusal?: string;
  statusLabel: string;
  createdAt: number;
  uploadedFiles: FileManaged[];
  amountToPay: string;
  report: AgentReportResponse | null;
  prescoringStatus: AgentRequestPrescoringStatusEnum;
}
